export default "__VITE_ASSET__CEWOufO1__"